import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ProvaScritta } from '../../../models/prova-scritta';
import { SezioneProveScritte } from '../../../models/sezioni/sezione-prove-scritte';

import { ProvaScrittaUpdateConcreteFormComponent } from './prova-scritta-update-concrete-form.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [modale_modifica_prova_scritta]',
  templateUrl: 'prova-scritta-modal-update.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ProvaScrittaMoldaUpdateComponent {
  @Output() onReturn: EventEmitter<SezioneProveScritte> = new EventEmitter<SezioneProveScritte>();
  @ViewChild('formProvaScritta') formProvaScritta: ProvaScrittaUpdateConcreteFormComponent;

  inizializza(urlUpdate: string, provaScritta: ProvaScritta, idSezione: string) {
    this.formProvaScritta.inizializza(urlUpdate, provaScritta, idSezione);
    openModal('modaleUpdateProvaScritta');
  }

  createForm() {
    this.formProvaScritta.createForm();
  }

  manageModal(sezione: SezioneProveScritte) {
    if (sezione) {
      closeModal('modaleUpdateProvaScritta');
      this.onReturn.emit(sezione);
    }
  }
}
